<template>
  <div class="mobile-nav" v-if="showNav">
    <div class="mobile-nav__sheet-backdrop" v-if="isMenuOpen" @click="closeMenu"></div>

    <transition name="sheet-up">
      <section v-if="isMenuOpen" class="mobile-nav__sheet" role="dialog" aria-label="Menu principal">
        <nav class="sheet-links">
          <router-link to="/profile" @click="closeMenu">
            <i class="fas fa-user"></i>
            Perfil
          </router-link>

          <button type="button" class="wallet-toggle" :class="{ open: walletOpen }" @click="walletOpen = !walletOpen">
            <span>
              <i class="fas fa-wallet"></i>
              Carteira
            </span>
            <i class="fas" :class="walletOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>

          <div v-if="walletOpen" class="wallet-group">
            <router-link to="/dashboard" :class="{ active: isRouteActive('/dashboard') }" @click="closeMenu">Dashboard</router-link>
            <router-link to="/trades" :class="{ active: isRouteActive('/trades') }" @click="closeMenu">Trades</router-link>
            <router-link to="/analysis" :class="{ active: isRouteActive('/analysis') }" @click="closeMenu">Análises</router-link>
          </div>

          <router-link to="/courses" @click="closeMenu">
            <i class="fas fa-play-circle"></i>
            Aulas
          </router-link>
          <router-link to="/notifications" @click="closeMenu">
            <i class="fas fa-bell"></i>
            Notificações
          </router-link>
          <router-link to="/support" @click="closeMenu">
            <i class="fas fa-headset"></i>
            Suporte
          </router-link>
          <button type="button" class="logout" @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            Logout
          </button>
        </nav>
      </section>
    </transition>

    <nav class="mobile-nav__bar" aria-label="Navegação inferior">
      <button type="button" class="bar-btn" :class="{ active: isMenuOpen }" @click="toggleMenu">
        <i class="fas fa-bars"></i>
        <span>Menu</span>
      </button>
      <router-link to="/" class="bar-btn" :class="{ active: isRouteActive('/') }">
        <i class="fas fa-home"></i>
        <span>Início</span>
      </router-link>
      <router-link to="/dashboard" class="bar-btn" :class="{ active: isRouteActive('/dashboard') }">
        <i class="fas fa-chart-line"></i>
        <span>Dashboard</span>
      </router-link>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'MobileBottomNav',
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isMenuOpen: false,
      walletOpen: false
    };
  },
  watch: {
    $route() {
      this.closeMenu();
    }
  },
  methods: {
    isRouteActive(path) {
      return this.$route.path === path;
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      if (!this.isMenuOpen) this.walletOpen = false;
    },
    closeMenu() {
      this.isMenuOpen = false;
      this.walletOpen = false;
    },
    logout() {
      localStorage.removeItem('user-token');
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('zima_show_welcome_once');
      localStorage.removeItem('notifications-data');
      this.$store.dispatch('clearUser');
      this.$store.dispatch('clearBybitConnection');
      window.dispatchEvent(new CustomEvent('notifications-updated', { detail: [] }));
      this.closeMenu();
      this.$router.replace({ name: 'Login' });
    }
  }
};
</script>

<style scoped>
.mobile-nav {
  display: none;
}

@media (max-width: 767px) {
  .mobile-nav {
    display: block;
    position: sticky;
    bottom: 0;
    z-index: 1500;
    background: transparent;
    margin-top: auto;
  }

  .mobile-nav__sheet-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1400;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
  }

  .mobile-nav__sheet {
    position: fixed;
    left: 0;
    right: 0;
    bottom: calc(var(--mobile-nav-h) + env(safe-area-inset-bottom));
    z-index: 1401;
    margin: 0 10px;
    background: linear-gradient(180deg, #121727 0%, #0f1422 100%);
    border: 1px solid rgba(115, 148, 240, 0.32);
    border-radius: 16px;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
    max-height: min(72vh, 520px);
    overflow: auto;
  }

  .sheet-header {
    display: none;
  }

  .sheet-links {
    display: grid;
    gap: 8px;
    padding: 12px;
  }

  .sheet-links a,
  .wallet-toggle,
  .logout {
    height: 42px;
    border-radius: 10px;
    border: 1px solid rgba(115, 148, 240, 0.28);
    background: rgba(18, 26, 42, 0.55);
    color: #eef2ff;
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    padding: 0 12px;
    font-weight: 600;
    font-size: 0.95rem;
  }

  .wallet-toggle {
    justify-content: space-between;
  }

  .wallet-toggle.open {
    border-color: rgba(115, 148, 240, 0.5);
    background: linear-gradient(120deg, rgba(78, 115, 223, 0.26), rgba(155, 89, 182, 0.18));
  }

  .wallet-toggle > span {
    display: inline-flex;
    align-items: center;
    gap: 10px;
  }

  .wallet-group {
    display: grid;
    gap: 6px;
    margin-top: 2px;
    padding-left: 8px;
    border-left: 2px solid rgba(115, 148, 240, 0.35);
  }

  .wallet-group a {
    height: 40px;
    border-radius: 8px;
    background: rgba(78, 115, 223, 0.12);
    border: 1px solid rgba(115, 148, 240, 0.28);
    font-weight: 500;
    font-size: 0.92rem;
    padding: 0 12px;
  }

  .wallet-group a.active {
    color: #fff;
    border-color: transparent;
    background:
      linear-gradient(120deg, rgba(78, 115, 223, 0.92), rgba(155, 89, 182, 0.92)) padding-box,
      linear-gradient(120deg, rgba(78, 115, 223, 0.92), rgba(155, 89, 182, 0.92)) border-box;
  }

  .logout {
    background: linear-gradient(135deg, #5f27cd 0%, #3498db 100%);
    border: none;
    font-weight: 700;
  }

  .logout:hover {
    background: linear-gradient(135deg, #4e73df 0%, #9b59b6 100%);
  }

  .mobile-nav__bar {
    position: relative;
    left: auto;
    right: auto;
    bottom: auto;
    z-index: 1;
    height: calc(var(--mobile-nav-h) + env(safe-area-inset-bottom));
    padding: 8px 10px calc(8px + env(safe-area-inset-bottom));
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    background: rgba(11, 14, 22, 0.96);
    border-top: 1px solid rgba(115, 148, 240, 0.24);
    backdrop-filter: blur(12px);
  }

  .bar-btn {
    border: 1px solid rgba(115, 148, 240, 0.18);
    border-radius: 10px;
    background: rgba(12, 17, 27, 0.85);
    color: #d5ddf3;
    text-decoration: none;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    font-size: 0.74rem;
    font-weight: 700;
  }

  .bar-btn i {
    font-size: 1rem;
  }

  .bar-btn.active {
    color: #fff;
    border-color: transparent;
    background:
      linear-gradient(120deg, rgba(78, 115, 223, 0.9), rgba(155, 89, 182, 0.9)) padding-box,
      linear-gradient(120deg, rgba(78, 115, 223, 0.9), rgba(155, 89, 182, 0.9)) border-box;
    box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.05) inset, 0 8px 16px rgba(40, 62, 122, 0.45);
  }

  .sheet-up-enter-active,
  .sheet-up-leave-active {
    transition: transform 0.2s ease, opacity 0.2s ease;
  }

  .sheet-up-enter-from,
  .sheet-up-leave-to {
    transform: translateY(16px);
    opacity: 0;
  }
}
</style>
